// ====== CONFIG (your actual values) ======
const GIFT_VARIANT_ID = 52262123143504; // your gift variant
const THRESHOLD_CENTS = 30000;          // 30000 = 300.00 лв minimum subtotal
const CURRENCY_SYMBOL = "лв";           // your store currency symbol
// ========================================

// helper: format cents to "лв300.00"
function formatMoney(cents) {
  const value = (cents / 100).toFixed(2);
  return `${CURRENCY_SYMBOL}${value}`;
}

// Fetch current cart JSON
async function getCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return res.json();
}

// Add the free gift (qty 1)
async function addGift() {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: GIFT_VARIANT_ID,
      quantity: 1
    })
  });
}

// Remove gift line item (uses the cart line "key")
async function removeGift(lineKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      quantity: 0
    })
  });
}

// Force gift back to quantity 1 if someone tries to bump it to 2+
async function normalizeGiftQuantity(lineKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      quantity: 1
    })
  });
}

// Update the visual progress bar / message in cart drawer
function updateProgressBar(subtotalCents, hasGift) {
  const bar = document.querySelector('[data-free-gift-bar]');
  const msg = document.querySelector('[data-free-gift-msg]');
  const fill = document.querySelector('[data-free-gift-fill]');

  if (!bar || !msg || !fill) return;

  const unlocked = subtotalCents >= THRESHOLD_CENTS || hasGift;
  const progress = Math.min(subtotalCents / THRESHOLD_CENTS, 1);

  fill.style.width = (progress * 100).toFixed(0) + '%';

  if (unlocked) {
    msg.textContent = "🎁 Подаръкът е отключен! Ще бъде изпратен безплатно.";
    bar.classList.add('is-unlocked');
  } else {
    const diff = THRESHOLD_CENTS - subtotalCents;
    msg.textContent = `Остават ${formatMoney(diff)} до безплатния подарък 🎁`;
    bar.classList.remove('is-unlocked');
  }
}

// Refresh the cart drawer HTML so it stays in sync after we modify cart
// Impact 4.4.0 renders the cart drawer via a section. We re-request that section.
function refreshCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const sectionId = drawer.getAttribute('data-section-id');
  if (!sectionId) return;

  fetch(`/?section_id=${sectionId}`)
    .then(r => r.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const updated = tempDiv.querySelector('[data-cart-drawer]');
      if (updated) {
        drawer.innerHTML = updated.innerHTML;
      }

      // After redraw, run sync again to re-bind UI state
      syncFreeGift();
    })
    .catch(e => console.error('Cart drawer refresh failed', e));
}

// MAIN LOGIC
async function syncFreeGift() {
  try {
    const cart = await getCart();

    const qualifies = cart.items_subtotal_price >= THRESHOLD_CENTS;

    // detect gift in cart, track its line key + quantity
    let giftLineItem = null;
    cart.items.forEach(item => {
      if (item.id === GIFT_VARIANT_ID) {
        giftLineItem = item;
      }
    });

    // 1. Customer qualifies but doesn't have gift -> add it
    if (qualifies && !giftLineItem) {
      await addGift();
      // refresh UI after add
      refreshCartDrawer();
      return; // we'll resync after refresh
    }

    // 2. Customer does NOT qualify but gift is in cart -> remove it
    if (!qualifies && giftLineItem) {
      await removeGift(giftLineItem.key);
      refreshCartDrawer();
      return;
    }

    // 3. Customer qualifies and has gift -> enforce quantity = 1
    if (qualifies && giftLineItem && giftLineItem.quantity > 1) {
      await normalizeGiftQuantity(giftLineItem.key);
      refreshCartDrawer();
      return;
    }

    // 4. Update progress bar display (no structural change)
    updateProgressBar(cart.items_subtotal_price, !!giftLineItem);

  } catch (err) {
    console.error('Free gift sync error:', err);
  }
}

// Attach listeners so we re-check after cart changes
function attachCartListeners() {
  // Run on load
  syncFreeGift();

  // Listen for quantity button clicks in the cart drawer (minus/plus/etc.)
  document.addEventListener('click', (e) => {
    if (
      e.target.matches('[name="minus"], [name="plus"], [data-qty-minus], [data-qty-plus], .cart-item__quantity-button')
    ) {
      // Give Shopify/Impact time to update cart, then resync
      setTimeout(syncFreeGift, 500);
    }
  });

  // Observe cart drawer mutations (Impact re-renders drawer via AJAX)
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    const observer = new MutationObserver(() => {
      // Whenever cart drawer content changes, keep rules enforced
      syncFreeGift();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
}

// Boot after DOM is ready
document.addEventListener('DOMContentLoaded', attachCartListeners);

